// This component is used a generic card to display data for either excursions or OBS
import { Text } from '../text/Text';
import { Button } from '../button/Button';
import { Image } from '../image/Image';
import styles from './postbookingcard.module.scss';
import { getDynamicMediaPath, getObsBaseImagePath } from '@msc-b2c/shared-utils';

const fallbackPlaceholderImage = `${
  getObsBaseImagePath() || '/content/dam/msc-cruises/b2c-assets/obs'
}/card_placeholder.png`;
const placeholderImage = getDynamicMediaPath('card_placeholder') || fallbackPlaceholderImage;

//Component for the skeleton of PostBookingCard
export const PostBookingCardSkeleton = () => {
  return (
    <div className={`${styles.postBookingCard} ${styles.postBookingCardSkeleton}`}>
      <div className={styles.imageArea}>
        <Image
          src={placeholderImage}
          alt=""
          styleOption={styles.logo}
        />
      </div>
      <div className={styles.textArea}>
        <div className={styles.cardBody}>
          <div className={styles.preTitleArea}>
            <Text
              text={'.'}
              styleOption={styles.preTitle}
            />
          </div>
          <div className={styles.descriptionArea}>
            <Text
              text={'.'}
              styleOption={styles.preTitle}
            />
          </div>
        </div>
        <div className={styles.cardFooter}>
          <div className={styles.buttonArea}>
            <Button
              text={'.'}
              styleOption={`cmp-button__primary  ${styles.button}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
